import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../shared/services/auth.service';
import { SidenavService } from '../../shared/services/sidenav.service';
import { LanguageService } from '../../shared/services/language.service';
import { GCMService } from '../../shared/services/gcm.service';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { AddRegionDialogComponent } from '../add-region-dialog/add-region-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { ManageGcmDialogComponent } from '../manage-gcm-dialog/manage-gcm-dialog.component';
import { Router } from '@angular/router';
import { FormBuilder, Validators } from '@angular/forms';
import { ScrollControlService } from '../../shared/services/scroll-control.service';

@Component({
  standalone: false,
  selector: 'app-gcm-component',
  templateUrl: './gcm-component.component.html',
  styleUrls: ['./gcm-component.component.css']
})
export class GcmComponentComponent implements OnInit {

  variables: any;
  isOpen: boolean = false;
  userName: any;
  shouldPinSidenav: boolean = false;
  dataSourceGCM = new MatTableDataSource();
  colorWhite = '#fff';
  displayedColumns1: string[] = ['gcm', 'cost', 'actions'];
  currentSelectedRegion: string = '';
  currentGCM: any;
  regions: any = [];
  filteredRegions: any = [];
  allRegions: any = [];
  newRegion: any = [];
  showTable: boolean = false;
  showAddRegion: boolean = false;
  formGroup1: any;

  constructor(
    public authService: AuthService,
    private sidenavService: SidenavService,
    private languageService: LanguageService,
    private GCMService: GCMService,
    public dialog: MatDialog,
    private router: Router,
    private _formBuilder: FormBuilder,
    private scrollService: ScrollControlService
  ) { }

  ngOnInit(): void {
    this.scrollService.setScroll(true);

    this.languageService.translations$.subscribe((vars: any) => {
      this.variables = vars;
    });

    this.formGroup1 = this._formBuilder.group({
      regionsFilterCtrl: [''],
      regionCtrl: ['', Validators.required],
    });

    this.userName = sessionStorage.getItem("username");

    //isto vai ter de passar a vir do serviço

    this.allRegions = [
      this.variables.global,
      this.variables.albania,
      this.variables.germany,
      this.variables.andorra,
      this.variables.austria,
      this.variables.belgic,
      this.variables.biolorussia,
      this.variables.bosniaHerzeg,
      this.variables.bulgaria,
      this.variables.cazaqui,
      this.variables.cyprus,
      this.variables.croacia,
      this.variables.dinamark,
      this.variables.slovaquia,
      this.variables.slovenia,
      this.variables.spain,
      this.variables.estonia,
      this.variables.finland,
      this.variables.france,
      this.variables.grecce,
      this.variables.hungary,
      this.variables.ireland,
      this.variables.iceland,
      this.variables.italy,
      this.variables.leton,
      this.variables.liechtenstein,
      this.variables.lituania,
      this.variables.luxemburg,
      this.variables.malta,
      this.variables.moldavia,
      this.variables.monaco,
      this.variables.montenegro,
      this.variables.norway,
      this.variables.holland,
      this.variables.poland,
      this.variables.portugal,
      this.variables.ceczRep,
      this.variables.macedon,
      this.variables.england,
      this.variables.northIreland,
      this.variables.scotland,
      this.variables.gales,
      this.variables.romain,
      this.variables.russia,
      this.variables.sanMarino,
      this.variables.servia,
      this.variables.sweden,
      this.variables.switzerland,
      this.variables.turkey,
      this.variables.ucraine,
      this.variables.vatican,
    ];

    this.newRegion = [
      { gcm: 0, cost: 0 },
      { gcm: 1, cost: 0 },
      { gcm: 2, cost: 0 },
      { gcm: 3, cost: 0 },
      { gcm: 4, cost: 0 },
      { gcm: 5, cost: 0 },
      { gcm: 6, cost: 0 },
      { gcm: 7, cost: 0 },
      { gcm: 8, cost: 0 }
    ]

    this.GCMService.getGCMRegions().subscribe(data => {
      data.forEach((region: any) => {
        this.regions.push(
          this.allRegions.find((item: any) => item.value == region.name)
        );
        this.allRegions.splice(this.allRegions.indexOf(this.allRegions.find((item: any) => item.value == region.name)), 1);
      })
      this.filteredRegions = this.regions;
      this.filteredRegions.sort((a: any, b: any) => {
        if (a.name < b.name)
          return -1;
        else if (a.name > b.name)
          return 1
        else
          return 0
      });
    })

    this.formGroup1.get('regionsFilterCtrl').valueChanges.subscribe((value: any) => {
      this.filterRegions();
    })


  }

  onSidenavToggle() {
    this.isOpen = !this.isOpen;
    this.sidenavService.sideNavState$.next(this.isOpen);
  }

  onCheckboxChange(event: any) {
    this.shouldPinSidenav = event;
    this.sidenavService.shouldPinSidenavState.next(this.shouldPinSidenav);
  }

  changeRegion(event: any) {
    this.showTable = true;
    this.currentSelectedRegion = event.value;
    this.GCMService.getRegionGCMs(event.value).subscribe((data: any) => {
      if (data.length > 0) {
        this.dataSourceGCM.data = data[0].gcms;
        this.currentGCM = data[0];
      }
      else {
        this.dataSourceGCM.data = this.newRegion;
        this.currentGCM = {
          id: null,
          region: this.currentSelectedRegion,
          gcms: this.newRegion
        }
      }
    })
  }

  editGCM(element: any) {
    const region = this.regions.find((item: any) => item.value == this.currentSelectedRegion)

    const data = {
      title: this.variables.editGCM,
      element: { "region": region, "gcm": element.gcm, "cost": element.cost },
    }

    let dialogRef = this.dialog.open(ManageGcmDialogComponent, {
      data: data
    });

    dialogRef.afterClosed().subscribe((result: any) => {
      if (result) {
        this.dataSourceGCM.data.forEach((item: any) => {
          if (item.gcm == element.gcm) {
            item.cost = result.data;
          }
        })
      }
    })
  }


  saveGCM() {

    let gcm = {
      id: this.currentGCM.id,
      region: this.currentGCM.region,
      gcms: this.dataSourceGCM.data
    }

    if (this.currentGCM.id) {
      this.GCMService.updateGCM(this.currentGCM.id, gcm);
    }
    else {
      this.GCMService.addGCM(gcm);
    }
  }


  addRegion() {
    // Prepare data to be passed to dialog component

    const data = {
      title: this.variables.addRegion,
      regions: this.allRegions
    }
    let dialogRef = this.dialog.open(AddRegionDialogComponent, {
      data: data
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        const newRegion = this.allRegions.find((item: any) => item.value == result.data);
        this.filteredRegions.push(newRegion);
        this.filteredRegions.sort((a: any, b: any) => {
          if (a.name < b.name)
            return -1;
          else if (a.name > b.name)
            return 1
          else
            return 0
        });
        this.changeRegion(newRegion);
        this.formGroup1.get("regionCtrl").setValue(this.currentSelectedRegion);
        this.allRegions.splice(this.allRegions.indexOf(this.allRegions.find((item: any) => item.value == result.data)), 1);
      }
    })
  }

  filterRegions() {
    let search = this.formGroup1.get('regionsFilterCtrl').value;
    if (!search) {
      this.filteredRegions = (this.regions.slice());
      return;
    }
    else {
      search = search.toLowerCase();
    }

    this.filteredRegions = this.regions.filter((region: any) => region.name.toLowerCase().indexOf(search) > -1);
  }

}
